import React, { useEffect, useState } from "react";
import Table from "components/Table";
import { Container, Spinner } from "reactstrap";
import { FormInputs, FormSelects } from "components/FormInputSelect";
import CustomButton from "components/CustomButton";
import { Sort, Bell, DateCalender, ChevronUp, ChevronDown } from "assets";
import { BiFilter } from "react-icons/bi";
import { BiPlus } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import data from "pages/dashboard/dashboardDummy";
import { useNavigate } from "react-router-dom";
import Pagination from "components/Pagination";
import { API_GET_MAMBOO } from "services";
import { getCookie } from "services/cookies";
import './transaksi.scss'
import { validateAlert } from "components/Alert";
import TableLoading from "components/TableLoading";
import useLoginStore from "hooks/useLoginStore";
import ModalImport from "components/ModalImport";

const Transaksi = () => {
  const { profile, isVerified } = useLoginStore()
  // `value` adalah parameter `type` untuk GET /api/transaction/get-list.
  // `key` hanya dipakai sebagai nilai option di dropdown jenis transaksi:
  // FormSelects mencocokkan option lewat `Options && Value`, sehingga nilai
  // falsy tidak pernah cocok — dan Riwayat Transaksi memang ber-`value` "".
  const menu = [
    { key: 'lor', label: 'List of Request', value: 'lor' },
    { key: 'lt', label: 'List Transaksi', value: 'lt' },
    { key: 'riwayat', label: 'Riwayat Transaksi', value: '' },
  ]
  const menuOptions = menu.map(({ key, label }) => ({ value: key, label }))
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState()
  const [activeMenu, setActiveMenu] = useState(0)
  const [isShow, setIsShow] = useState({
    label: "5",
    value: 5,
  });
  const [createTransaksi, setCreateTransaksi] = useState("");
  const [listTransaksi, setListTransaksi] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [readOnly, setReadOnly] = useState(false);

  const navigate = useNavigate()

  const handleClickMenu = (index) => {
    setActiveMenu(index)
  }

  // activeMenu tetap disimpan sebagai indeks supaya pemanggilan API dan
  // dependensi useEffect yang sudah ada tidak perlu ikut berubah.
  const handleChangeMenu = (option) => {
    const index = menu.findIndex((item) => item.key === option?.value)
    if (index !== -1) handleClickMenu(index)
  }

  // Tinggi dropdown disamakan dengan .btn-md (padding 16px + line-height 24px)
  // supaya sejajar dengan tombol Filter dan Pilih Tanggal di sebelahnya.
  const transactionTypeSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "56px",
      borderRadius: "8px",
      borderColor: 'var(--border-strong)',
      boxShadow: "none",
      "&:hover": { borderColor: 'var(--border-strong)' },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 16px" }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--text-primary)',
      fontSize: "16px",
      fontWeight: 500,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    // Menu harus di atas header tabel saat dropdown dibuka.
    menu: (base) => ({ ...base, zIndex: 5 }),
  }

  const columnRefs = [
    {
      dataField: "transaction_code",
      text: "Transaction",
      // style: {
      //   flex: 'none',
      //   width: '15%'
      // }
    },
    {
      dataField: 'title',
      text: "Judul Lagu",
      // style: {
      //   flex: 'none',
      //   width: '10%'
      // }
    },
    {
      dataField: "transaction_date",
      text: (
        <>
          <span>Transaction Date</span> <Sort />
        </>
      ),
      sort: true,
      // headerStyle: (column, colIndex) => ({
      //   ...column,
      //   width: '20%'
      // }),
      // style: {
      //   flex: 'none',
      //   width: '15%'
      // },
      formatter: (cell, row) => cell.split('T')[0]
    },
    {
      dataField: "client",
      text: "Client",
      // style: {
      //   flex: 'none',
      //   width: '18%',
      // }
    },
    {
      dataField: "total",
      text: "Total Transaction",
      // style: {
      //   flex: 'none',
      //   width: '15%'
      // }
    },
    {
      dataField: "status",
      text: "Status",
      // style: {
      //   flex: 'none',
      //   width: '15%'
      // }
      formatter: (cell, row) => statusFormatter(cell)
    },
    // {
    //   dataField: "document",
    //   text: "Document",
    //   // style: {
    //   //   flex: 'none',
    //   //   width: '8%'
    //   // }
    // },
  ];

  function statusFormatter(cell) {
    switch (cell) {
      case 'Draft':
        return <span style={{ color: 'var(--text-muted)' }}>{cell}</span>
      case 'Invoice':
        return <span style={{ color: 'var(--brand)' }}>{cell}</span>
      case 'Quotation':
        return <span style={{ color: '#CD7B2E' }}>{cell}</span>
      case 'Selesai':
        return <span style={{ color: 'green' }}>{cell}</span>
      case 'Batal':
        return <span style={{ color: 'red' }}>{cell}</span>
    }
  }

  const getDetail = async (id, status) => {
    await API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0], stat_label: status }] } })
      })
  }

  const expandComponent = {
    renderer: row => (
      <div className='expand-container'>
        {Object.keys(row.expand).map((item, i) => (
          <>
            <div className='expand-content'>
              <span className="expand-title" style={{ textTransform: 'capitalize', fontSize: "16px" }}>{item.split('_').join(' ')}</span>
              <div className='expand-data'>
                {/* {row.expand[item].map((val, i) => (
                <span className='expand-text'>{val}</span>
              ))} */}
                <span className='expand-text'>{row.expand[item]}</span>
              </div>
            </div>
            {i === (Object.keys(row.expand).length - 1) && (
              <CustomButton
                label={
                  row.status === 'Draft' ?
                    'Detail Draft' :
                    row.status === 'Quotation' ?
                      'Detail Quotation' :
                      row.status === 'Invoice' ?
                        'Detail Invoice' :
                        'Detail Transaksi'
                }
                size="btn-sm"
                className="btn-full button-import mt-5 align-self-center ms-4"
                style={{ width: 'auto' }}
                // onClick={(e) => handleOnClick('editLagu', row.song_id, row)}
                onClick={() => getDetail(row.Transaction_id, row.status)}
              />
            )}
          </>
        ))}
      </div>
    ),
    onlyOneExpanding: true,
    parentClassName: (isExpanded, row, rowIndex) => {
      return 'parent-expand'
    },
    className: (isExpanded, row, rowIndex) => {
      return 'row-expand'
    },
    expandByColumnOnly: true,
    showExpandColumn: true,
    expandColumnPosition: 'right',
    expandHeaderColumnRenderer: () => "",
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <ChevronUp />
        )
      } else {
        return (
          <ChevronDown />
        )
      }
    }
  }

  const options = [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
  ];

  const customStylesFilter = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      width: "75px",
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      width: "75px",
      padding: "0px",
    }),

    singleValue: (provided, state) => ({
      ...provided,
      textAlign: "center",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "30px",
    }),
  };

  const onChangeSelect = (e) => {
    // isShow berbentuk { label, value } — menyimpan e.value saja membuat
    // isShow.value jadi undefined dan selectnya kehilangan nilai terpilih.
    setIsShow({ label: e.label, value: e.value });
  };

  const handleOnClick = async (e) => {
    await setCreateTransaksi(e);
  };

  const handleClickNumber = async (page) => {
    await API_GET_MAMBOO.dynamic.getTransaction(page, isShow.value, menu[activeMenu].value).then((response) => {
      setPage(page)

      let totalPage = Math.ceil(response.total / isShow.value)
      setTotalPage(totalPage)
      setListTransaksi(response.data.map((val, index) => {
        return {
          ...val,
          id: index
        }
      }))
    })
  }

  const onClickCreateTransaksi = async () => {
    let active = []
    let inactive = []
    let song = []

    await API_GET_MAMBOO.dynamic
      .getListPencipta(1, 5, "active", '')
      .then((resp) => {
        active = resp.data
      });
    await API_GET_MAMBOO.dynamic
      .getListPencipta(1, 5, "inactive", '')
      .then((resp) => {
        inactive = resp.data
      });

    await API_GET_MAMBOO.dynamic
      .getSongList(1, 5, '')
      .then((resp) => {
        song = resp.data
      })

      if([...active, ...inactive].length > 0) {
        if(song.length > 0) {
          return navigate("/transaksi/create");
        } else {
          return validateAlert({
            icon: 'warning',
            title: 'Data Lagu Tidak ada',
            text: 'Harap buat data lagu terlebih dahulu, setelahnya anda bisa membuat transaksi.',
            confirmButtonText: 'Menuju Halaman Katalog Lagu',
            confirmed: () => profile.role_code == 2 ? null : navigate("/katalog-lagu")
          })
        }
      } else {
        return validateAlert({
          icon: 'warning',
          title: 'Data Anggota atau Lagu tidak ada',
          text: 'Harap buat data anggota terlebih dahulu, lalu data lagu, setelahnya anda bisa membuat transaksi.',
          confirmButtonText: 'Menuju Halaman Anggota',
          confirmed: () => profile.role_code == 2 ? null : navigate("/pencipta")
        })
        
      }
  }

  const getList = async () => {
    setIsLoading(true)
    await API_GET_MAMBOO.dynamic.getTransaction(page, isShow.value, menu[activeMenu].value)
      .then((response) => {

        let totalPage = Math.ceil(response.total / isShow.value)
        setTotalPage(totalPage)
        setListTransaksi(response.data.map((val, index) => {
          return {
            ...val,
            id: index
          }
        }
        ))
        setIsLoading(false)
      })
  }

  const modalContentVerified = () => {
    return (
      <div className="custom-modal-body">
        <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
          <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
      </div>
    )
  }

  useEffect(() => {
    getList();

    if(profile.access && profile?.access?.length > 0) {
      profile.access.filter((val) => {
        if(val.access_name === "Transaksi") {
          setReadOnly(val.is_read_only)
        } else if (val.access_name === "Super Admin") {
          setReadOnly(val.is_read_only)
        }
      })
    }
  }, [activeMenu, isShow])

  return (
    <>
      {/* {createTransaksi === "createTransaksi" ? (
        <AddTransaksi handleBack={(e) => setCreateTransaksi("")} />
      ) : ( */}
      <Container fluid className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>Transaksi</h1>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          {/* <div className="frame-filters">
            <p className="text-show">Show :</p>
            <FormSelects
              options={options}
              onChange={onChangeSelect}
              defaultValue={isShow}
              value={isShow}
              styles={customStylesFilter}
            />
          </div> */}
          <div className="frame-filters">
            {/* Jenis transaksi. Dulu tiga tab bersebelahan yang memakan ~425px
                dan membuat baris toolbar meluber sampai tombol Create
                terpotong. Sebagai dropdown, isinya sama tapi cuma ~220px. */}
            <div className="transaction-type-filter">
              <FormSelects
                options={menuOptions}
                value={menu[activeMenu].key}
                onChange={handleChangeMenu}
                styles={transactionTypeSelectStyles}
              />
            </div>
            <div className="frame-sub-filters">
              <div className="frame-cari-nama">
                <div className="box-text-cari-nama">
                  <span className="text-cari-nama">Cari Judul</span>
                </div>
                <FormInputs
                  placeholder="Masukkan Nama"
                  className="frame-cari-nama"
                />
                <div className="frame-search">
                  <FiSearch />
                </div>
              </div>
            </div>
            <CustomButton
              label="Filter"
              LabelIcon={BiFilter}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
            <CustomButton
              label="Pilih Tanggal"
              LabelIcon={DateCalender}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
          </div>
          {/* Grup tersendiri agar bisa didorong ke kanan lewat margin-left:auto
              — bertahan juga saat toolbar membungkus ke baris berikutnya,
              berbeda dengan mengandalkan justify-content: space-between. */}
          {getCookie("publisher") == 3 || readOnly ? null : (
            <div className="frame-filters frame-filters-end">
              <CustomButton
                label="Create"
                color="primary-btn"
                size="md"
                iconPosition="left"
                LabelIcon={BiPlus}
                className="button-add-transaksi"
                onClick={(e) => {
                  onClickCreateTransaksi()
                }}
              />
            </div>
          )}
        </div>
          {isLoading ? (
            <div className="">
              {/* <Spinner size="lg" color="light" /> */}
              <TableLoading columnRefs={columnRefs} isShow={isShow.value} />
            </div>
          ) : (
            <Table
              columnRefs={columnRefs}
              dataTable={listTransaksi}
              expandRow={expandComponent}
              noDataText="Tidak ada transaksi"
            />
          )}
        <Pagination
          isTotalPage={totalPage}
          isPage={page}
          handleClickNumber={handleClickNumber}
          pageToShow={6}
        />
      </Container>
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
      {/* )} */}
    </>
  );
};

export default Transaksi;
